/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
 */
export interface ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries {
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    loaderVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    firmwareVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    uiVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    customFirmware1Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    customFirmware2Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    customFirmware3Version: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries
     */
    count: number | null;
}

export function ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesFromJSON(json: any): ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries {
    return ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesFromJSONTyped(json, false);
}

export function ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'customFirmware1Version': json['customFirmware1Version'],
        'customFirmware2Version': json['customFirmware2Version'],
        'customFirmware3Version': json['customFirmware3Version'],
        'count': json['count'],
    };
}

export function ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesToJSON(value?: ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'customFirmware1Version': value.customFirmware1Version,
        'customFirmware2Version': value.customFirmware2Version,
        'customFirmware3Version': value.customFirmware3Version,
        'count': value.count,
    };
}

